import React from 'react';
import { useTranslation } from 'react-i18next';
import closeButtonPic from '../../../assets/designSystem/icons/close.svg';
import Button from '../../../components/Inputs/Button';
import './popup.css';

export default function coldOrEar({ babyOrChild, callback }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal__backdrop" />
      <div className="modal__popup">
        <div className="popup__container">
          <img
            src={closeButtonPic}
            alt="close button"
            className="popup__closeBtn"
            role="presentation"
            width="24"
            onClick={callback}
          />
          <div className="popup__content">
            <h4 className="popup__title">
              {t(`popUps.coldOrEar.${babyOrChild}.title`)}
            </h4>
            <p>{t(`popUps.coldOrEar.${babyOrChild}.p1`)}</p>
            <p>{t('popUps.coldOrEar.p2')}</p>
            <div>
              <p>{t('popUps.coldOrEar.p3')}</p>
              <ul>
                <li>{t(`popUps.coldOrEar.${babyOrChild}.li1`)}</li>
                <li>{t('popUps.coldOrEar.li2')}</li>
                <li>{t('popUps.coldOrEar.li3')}</li>
                <li>{t(`popUps.coldOrEar.${babyOrChild}.li4`)}</li>
              </ul>
            </div>
            <p>{t('popUps.coldOrEar.p4')}</p>
          </div>
          <div className="popup__button">
            <Button width="fullWidth" hierarchy="primary" onClick={callback}>
              {t('popUps.button')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
